// Deterministic chronological valuation shared with the browser. No database access.
const EPS = 1e-8;
const idDe = m => String(m._id || m.id || m.localId || '');
const tipoMovimiento = m => m.tipo === 'SALIDA' && m.subTipo === 'VENTA' ? 'VENTA' : m.tipo;
function calcularInventario(movimientos, metodo = 'PROMEDIO') {
  const saldos = {}, costos = {}, errores = [];
  const list = (movimientos || []).filter(m => !m.anulado).slice().sort((a,b) =>
    new Date(a.fecha) - new Date(b.fecha) ||
    String(a.ordenInventario || (a.createdAt ? new Date(a.createdAt).toISOString() : idDe(a))).localeCompare(String(b.ordenInventario || (b.createdAt ? new Date(b.createdAt).toISOString() : idDe(b)))) ||
    ((a.origenOperacion === 'LIMPIEZA' && a.tipo === 'SALIDA' ? 0 : 1) - (b.origenOperacion === 'LIMPIEZA' && b.tipo === 'SALIDA' ? 0 : 1)) ||
    idDe(a).localeCompare(idDe(b)));
  for (const m of list) {
    const pid = String(m.productoId);
    const saldo = saldos[pid] || (saldos[pid] = { cantidad: 0, valor: 0, promedio: 0, lotes: [] });
    const cantidad = Number(m.cantidad), precio = Number(m.precio);
    if (!Number.isFinite(cantidad) || cantidad <= 0 || !Number.isFinite(precio) || precio < 0 || !Number.isFinite(new Date(m.fecha).getTime())) {
      errores.push({ id: idDe(m), productoId: pid, fecha: m.fecha, mensaje: 'Cantidad, precio o fecha inválidos' }); continue;
    }
    if (tipoMovimiento(m) === 'ENTRADA') {
      saldo.valor += cantidad * precio; saldo.cantidad += cantidad;
      saldo.lotes.push({ cantidad, precio });
    } else {
      if (cantidad > saldo.cantidad + EPS) errores.push({ id: idDe(m), productoId: pid, fecha: m.fecha, mensaje: 'Stock insuficiente', disponible: saldo.cantidad, requerido: cantidad });
      let costo = 0;
      if (metodo === 'FIFO' || metodo === 'LIFO') {
        let restante = cantidad;
        while (restante > EPS && saldo.lotes.length) {
          const pos = metodo === 'LIFO' ? saldo.lotes.length - 1 : 0;
          const lote = saldo.lotes[pos], toma = Math.min(restante, lote.cantidad);
          costo += toma * lote.precio; lote.cantidad -= toma; restante -= toma;
          if (lote.cantidad <= EPS) saldo.lotes.splice(pos,1);
        }
        if (restante > EPS) costo += restante * saldo.promedio;
      } else {
        costo = cantidad * saldo.promedio;
      }
      costos[idDe(m)] = costo / cantidad;
      saldo.cantidad -= cantidad; saldo.valor -= costo;
      if (Math.abs(saldo.cantidad) < EPS) { saldo.cantidad = 0; saldo.valor = 0; saldo.lotes = []; }
    }
    saldo.promedio = saldo.cantidad > EPS ? saldo.valor / saldo.cantidad : 0;
  }
  return { saldos, costos, errores };
}

export { calcularInventario, tipoMovimiento };
